<div class="modal-header compositions">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closemodel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{label}}</h4>
</div>
<div class="modal-body">
    <ul class="list-comp" *ngIf="compositions.length>0">
        <ng-container *ngIf="compositions[0].length>0">
            <li *ngFor="let comp of compositions[0]; let i=index;">
                <b *ngIf="comp.quantity>1">{{comp.quantity}}</b> {{comp.name}} {{comp.label}} <ng-container
                    *ngIf="comp.level">
                    ({{comp.size}})</ng-container>
            </li>
        </ng-container>

        <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
            <ng-container *ngIf="compositions[i].length>0">
                <li>
                    <ng-container *ngFor="let el of compositions[i];let j=index">
                        <b *ngIf="el.quantity>1">{{el.quantity}}</b> {{el.name}} {{el.label}}<ng-container
                            *ngIf="el.level">
                            ({{el.size}})
                        </ng-container> <b *ngIf="j!=compositions[i].length-1">OU </b>
                    </ng-container>
                </li>
            </ng-container>
        </ng-container>
    </ul>
</div>